import PropTypes from 'prop-types';
import { renderImage, POSTER_OVERLAY_LOGO_IMAGE } from 'helpers/ImageHelper';

const Logo = ({ breakpoint, logo, showName, theme }) => {
  if (!logo) return null;

  return renderImage({
    alt: showName,
    breakpoint,
    className: theme.logo,
    imageType: POSTER_OVERLAY_LOGO_IMAGE,
    src: logo,
  });
};

Logo.propTypes = {
  breakpoint: PropTypes.string,
  logo: PropTypes.string,
  showName: PropTypes.string,
  theme: PropTypes.shape({}),
};

Logo.defaultProps = {
  breakpoint: null,
  logo: null,
  showName: null,
  theme: {},
};

export default Logo;
